// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"455":"e2cc5639","873":"a2b76f6f"}[chunkId] + ".chunk.css";
};